module.exports = __webpack_public_path__ + "media/images/icons/icon_stop-1a238089d0c0563957a40e2079cf9f6e.svg";